// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx","493":"component---src-pages-blog-jsx"}[chunkId] || chunkId) + "-" + {"279":"52468fb865eab65e20f5","415":"b1011c78d28377019787","454":"2b58d6707215c2409425","493":"e896557cc615443a5608"}[chunkId] + ".js";
};